import { Component } from "react";
import { cn } from "@discovery/classnames";
import { pushModuleLinkTracking } from "@discovery/common-dplus/lib/adobe";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
import { TopShowCard } from "../../../cards";
import { Icon, Icons } from "../../../../atoms/icon";
import * as styles from "./styles.css";
export default class Top10ShowCarousel extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            const { id } = this.state;
            const rail = document.getElementById(`#rail${id}`);
            this.checkArrow();
            rail && rail.addEventListener("scroll", this.checkArrow);
        };
        this.componentWillUnmount = () => {
            const { id } = this.state;
            const rail = document.getElementById(`#rail${id}`);
            rail && rail.removeEventListener("scroll", this.checkArrow);
        };
        this.checkArrow = () => {
            const { id } = this.state;
            const rail = document.getElementById(`#rail${id}`);
            if (rail) {
                this.setState({
                    isLeftArrowVisible: rail.scrollLeft > 0 ? true : false,
                    isRightArrowVisible: rail.scrollWidth > rail.clientWidth &&
                        rail.scrollWidth - rail.scrollLeft > rail.clientWidth
                        ? true
                        : false,
                });
            }
        };
        this.sendAnalyticsEvents = (item, index) => {
            const indexValue = index + 1;
            const itemPosition = indexValue.toString();
            item.title &&
                item.route &&
                pushModuleLinkTracking(config.standardPageRouteFragments.home, itemPosition, item.title, "genre", "www.discoveryplus.in/home", item.route);
        };
        this.state = {
            isLeftArrowVisible: false,
            isRightArrowVisible: false,
            id: Math.random() * 1000,
        };
    }
    render() {
        const { cards, webAuthRedirectionUrl, ageConstraint, read } = this.props;
        const { id, isLeftArrowVisible, isRightArrowVisible } = this.state;
        const onLeftClick = () => {
            const { id } = this.state;
            const swipeValue = 28.5;
            const rail = document.getElementById(`#rail${id}`);
            const count = Math.floor(rail.clientWidth / swipeValue) - 1; //TODO-DPLUS: get card width dynamically
            rail &&
                rail.scrollTo({
                    left: rail.scrollLeft - swipeValue * count,
                    behavior: "smooth",
                });
        };
        const onRightClick = () => {
            const { id } = this.state;
            const swipeValue = 28.5;
            const rail = document.getElementById(`#rail${id}`);
            const count = Math.floor(rail.clientWidth / swipeValue) - 1; //TODO-DPLUS: get card width dynamically
            rail &&
                rail.scrollTo({
                    left: rail.scrollLeft + swipeValue * count,
                    behavior: "smooth",
                });
        };
        const RenderLeftIcon = () => {
            return (React.createElement(Icon, { type: Icons.AngleLeftIcon, color: "#FFF", className: styles.arrowIcon }));
        };
        const RenderRightIcon = () => {
            return (React.createElement(Icon, { type: Icons.AngleRightIcon, color: "#FFF", className: styles.arrowIcon }));
        };
        return (React.createElement("div", { className: cn(styles.railWrapper, styles.railWrapperWithPadding), id: "#topshows" },
            isLeftArrowVisible && (React.createElement("div", { className: cn(styles.arrow, styles.showsArrow, styles.leftArrow, styles.withbackground), onClick: onLeftClick },
                React.createElement(RenderLeftIcon, null))),
            React.createElement("div", { className: styles.container, id: `#rail${id}` }, cards.map((card, index) => (React.createElement(TopShowCard, Object.assign({}, card, { webAuthRedirectionUrl: webAuthRedirectionUrl, ageConstraint: ageConstraint, key: index, index: index + 1, read: read }))))),
            isRightArrowVisible && (React.createElement("div", { className: cn(styles.arrow, styles.showsArrow, styles.rightArrow, styles.withbackground), onClick: onRightClick },
                React.createElement(RenderRightIcon, null)))));
    }
}

